module.exports = __webpack_public_path__ + "bedacceb00355827f9b599efa9bacab1.png";